import React from "react";
import "./cabinet-card.scss";

function CabinetCard(props) {
  const displayedColors = props.data.colors ? Object.keys(props.data.colors).slice(0, 5) : [];

  return (
    <a href={`/cabinets/` + props.data.url} className="cabinet-card">
      <>
        <img src={props.data["imageurl"]} alt={`${props.data.altText} Thumbnail`} />
        <h3>{props.data.productName}</h3>
        <div className="product-colors">
          <span>Shown in {props.data.shownColor} finish</span>
          <div className="color-list">
            {displayedColors.length > 0 ? 
              displayedColors.map((key, i) => {
                const color = props.data.colors[key];
                return (
                  <div 
                    key={i} 
                    style={{ backgroundImage: `url(${color.colorimg})` }} 
                    className="color-name"
                  >
                    <div>{color.colorName}</div>
                  </div>
                );
              })
              : 'loading'}
            <div className="more-color">{props.data.moreColors || 'More colors available'}</div>
          </div>
        </div>
      </>
    </a>
  );
}

export default CabinetCard;
